import { createSession, sendMessageWs } from 'src/store/trading/bots/actions';
import { createBotsSlice } from 'src/store/shared/tradingBots/factory';
import { actionEsOnMessage } from '@skynet/data-ws-es';
import type { TradingState } from 'src/store/shared/tradingBots/types';
import { sendMessageAction } from 'src/store/shared/tradingBots/factoryActions';
import {
  selectorTradingLastMessageId,
  selectorTradingSessionDetails,
} from 'src/store/loans/bots/selectors';

const sendMessage = sendMessageAction({
  prefix: 'trading',
  selectorTradingSessionDetails,
  selectorTradingLastMessageId,
  sendMessage: sendMessageWs,
});

export const initialState: TradingState = {
  error: null,
  groupList: null,
  groupListStatus: null,
  messageStatus: null,
  messageLog: [],
  sessionCreateStatus: null,
  sessionDetails: null,
};

const bots = createBotsSlice({
  prefix: 'trading',
  sendMessage: sendMessageWs,
  createSession,
  onMessage: actionEsOnMessage,
  initialState,
});

export const botsActions = {
  ...bots.actions,
  createSession,
  sendMessage,
};

export default bots.reducer;
